import { jsx as _jsx } from "react/jsx-runtime";
import { useLayoutEffect, useMemo, useRef, useState } from 'react';
import styled from 'styled-components';
import { OLAF } from 'HubStyleTokens/colors';
import UIToggleGroup from 'UIComponents/input/UIToggleGroup';
import UIScrollContainer from 'UIComponents/scroll/UIScrollContainer';
import FilterToggle from './FilterOption';
const INPUT_HEIGHT = 32;
const MAX_HEIGHT = 192;
const StyledUIScrollContainer = styled(UIScrollContainer).withConfig({
  displayName: "FilterToggleGroup__StyledUIScrollContainer",
  componentId: "sc-1xbviq4-0"
})(["*::-webkit-scrollbar{display:none;}::-webkit-scrollbar-track{border-radius:8px;}*:hover::-webkit-scrollbar{display:block;width:8px;}*:hover::-webkit-scrollbar-thumb{border-radius:4px;background-color:rgba(235,240,245,1);box-shadow:0 0 1px rgba(255,255,255,0.5);}*::-webkit-scrollbar-thumb:hover{background-color:rgba(223,227,235,1);}"]);

function FilterToggleGroup({
  disabled,
  labelComponent: LabelComponent,
  multi,
  name,
  onChange,
  options,
  scrollable,
  value,
  virtualized
}) {
  const [scrollTop, setScrollTop] = useState(0);
  const scrollElementRef = useRef(null);
  const numOptions = options.length;

  const renderedOptions = () => {
    if (virtualized) {
      const startIndex = Math.floor(scrollTop / INPUT_HEIGHT);
      const endIndex = Math.min(numOptions - 1, Math.floor((scrollTop + MAX_HEIGHT) / INPUT_HEIGHT));
      const visibleOptions = [];

      for (let i = startIndex; i <= endIndex; i++) {
        const option = options[i];
        visibleOptions.push( /*#__PURE__*/_jsx(FilterToggle, {
          LabelComponent: LabelComponent,
          disabled: disabled,
          multi: !!multi,
          name: name,
          onChange: onChange,
          option: option,
          style: {
            position: 'absolute',
            top: `${i * INPUT_HEIGHT}px`,
            width: '100%'
          },
          value: value
        }, 'value' in option ? option.value : i));
      }

      return visibleOptions;
    }

    return options.map((option, index) => /*#__PURE__*/_jsx(FilterToggle, {
      LabelComponent: LabelComponent,
      disabled: disabled,
      name: name,
      multi: !!multi,
      onChange: onChange,
      option: option,
      value: value
    }, index));
  };

  const toggleGroupStyles = useMemo(() => {
    if (virtualized) {
      return {
        position: 'relative',
        height: numOptions * INPUT_HEIGHT
      };
    }

    return {};
  }, [numOptions, virtualized]);

  const renderedToggleGroup = /*#__PURE__*/_jsx(UIToggleGroup, {
    name: name,
    style: toggleGroupStyles,
    children: renderedOptions()
  });

  useLayoutEffect(() => {
    if (scrollElementRef.current) {
      const scrollElement = scrollElementRef.current;

      const scrollHandler = () => {
        setScrollTop(Math.max(scrollElement.scrollTop, 0));
      };

      scrollElement.addEventListener('scroll', scrollHandler);
      return () => scrollElement.removeEventListener('scroll', scrollHandler);
    }

    return () => {};
  }, []);

  if (scrollable || virtualized) {
    return /*#__PURE__*/_jsx(StyledUIScrollContainer, {
      gradientColor: OLAF,
      maxHeight: MAX_HEIGHT,
      scrollElementRef: scrollElementRef,
      size: 28,
      children: renderedToggleGroup
    });
  }

  return renderedToggleGroup;
}

export default FilterToggleGroup;